var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55049 1.98807H10.4712C10.9824 1.98956 11.3959 2.40468 11.3954 2.91592V3.32467H4.62621V2.91592C4.62572 2.40467 5.03924 1.98956 5.55049 1.98807ZM4.68925 13.0712V12.0063L11.3428 12.0075V13.999H5.61353C5.10229 13.9975 4.68877 13.5824 4.68925 13.0712ZM7.34199 13.331H8.67973V12.6664H7.34199V13.331ZM10.4604 1.33325H5.53976C4.67926 1.34497 3.99056 2.0509 4.0001 2.91143V13.0884C3.99056 13.9489 4.67926 14.6549 5.53976 14.6666H10.0157V13.9954H11.3444V14.6648H12.0001V2.91143C12.0096 2.0509 11.3209 1.34497 10.4604 1.33325ZM11.3318 11.3447H4.65979V4.00502H11.3318V11.3447Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.488aa88b7fa83cfde4707c3b0e3a02093638e64f3c70faa2d20cc933b455e362.svg";
export { ForwardRef as ReactComponent };